import axios from "@/utils/axios";

import { GetTeamRaidWishesResponse } from "@/api/teams/get-team-raid-wishes.response";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetCreatableGuildsResponse } from "@/api/teams/get-creatable-guilds.response";
import { GetOneGuildCharactersResponse } from "@/api/characters/get-one-guild-characters.response";
import { GetTeamsResponse } from "@/api/teams/get-teams.response";

import { Guid } from "@/domain/guid";
import { GetOneTeamPublicResponse } from "@/api/teams/get-one-team-public.response";

export interface CreateTeamRequest {
	name: string;
	region: string;
	mustAddMyCharacters: boolean;
}

export default {
	async getTeams(): Promise<GetTeamsResponse> {
		return (await axios().get("/teams/")).data;
	},
	async getCreatableGuilds(): Promise<GetCreatableGuildsResponse> {
		return (await axios().get("/teams/create")).data;
	},
	async createTeam(payload: CreateTeamRequest): Promise<void> {
		return (await axios().post("/teams/create/", payload)).data;
	},
	async createTeamFromGuild(region: string, realm: string, name: string): Promise<void> {
		return (await axios().post(`/teams/create/guild/${region}/${realm}/${name}/`)).data;
	},
	async getTeamSettings(teamID: Guid): Promise<any> {
		return (await axios().get(`/teams/${teamID}/settings`)).data;
	},
	async getTeamInfos(id: Guid): Promise<GetOneTeamResponse> {
		return (await axios().get(`/teams/${id}/`)).data;
	},
	async getPublicTeamInfos(inviteCode: string): Promise<GetOneTeamPublicResponse> {
		return (await axios().get(`/teams/${inviteCode}/public`)).data;
	},
	async getTeamInfosBySlug(slug: string): Promise<GetOneTeamResponse> {
		return (await axios().get(`/teams/slug/${slug}/`)).data;
	},
	async getTeamInfosBySlugs(region: string, realmSlug: string, nameSlug: string): Promise<GetOneTeamResponse> {
		return (await axios().get(`/teams/guilds/${region}/${realmSlug}/${nameSlug}/`)).data;
	},
	async getGuildCharacters(teamID: Guid): Promise<GetOneGuildCharactersResponse> {
		return (await axios().get(`/teams/${teamID}/guildCharacters/`)).data;
	},
	async getTeamCharacters(teamID: Guid): Promise<any[]> {
		return (await axios().get(`/teams/${teamID}/characters/`)).data;
	},
	async getTeamMembers(teamID: Guid): Promise<any[]> {
		return (await axios().get(`/teams/${teamID}/members/`)).data;
	},
	async syncGuildMembers(teamID: Guid): Promise<void> {
		return (await axios().put(`/teams/${teamID}/sync/`)).data;
	},
	async addCharacter(teamID: Guid, realm: string, name: string): Promise<void> {
		return (await axios().post(`/teams/${teamID}/addCharacter/${realm}/${name}`)).data;
	},
	async kickCharacter(teamID: Guid, characterID: Guid): Promise<void> {
		return (await axios().delete(`/teams/${teamID}/characters/${characterID}/kick`)).data;
	},
	async kickMember(teamID: Guid, userID: Guid): Promise<void> {
		return (await axios().delete(`/teams/${teamID}/members/${userID}/kick`)).data;
	},
	// async toggleApprovedCharacter(teamID: TID, characterID: TID): Promise<any> {
	// 	return (await axios().patch(`/teams/${teamID}/characters/${characterID}/toggleApproved`)).data;
	// },
	async toggleApprovedMember(teamID: Guid, userID: Guid): Promise<void> {
		return (await axios().patch(`/teams/${teamID}/members/${userID}/toggleApproved`)).data;
	},
	async togglePermissionMember(teamID: Guid, userID: Guid, permissionCode: number): Promise<void> {
		return (await axios().patch(`/teams/${teamID}/members/${userID}/togglePermission/${permissionCode}`)).data;
	},
	async leaveTeam(teamID: Guid): Promise<void> {
		return (await axios().delete(`/teams/${teamID}/leave`)).data;
	},

	async fetchInviteLinks(teamID: Guid): Promise<any> {
		return (await axios().get(`/teams/${teamID}/inviteLinks`)).data;
	},
	async createInviteLink(teamID: Guid): Promise<void> {
		return (await axios().post(`/teams/${teamID}/inviteLinks`)).data;
	},
	async deleteInviteLink(linkID: string): Promise<void> {
		return (await axios().delete(`/teams/inviteLinks/${linkID}`)).data;
	},
	async acceptInviteCode(inviteCode: string): Promise<void> {
		return (await axios().post(`/teams/invite/${inviteCode}/accept`)).data;
	},

	async unlinkDiscord(teamID: Guid): Promise<void> {
		return (await axios().delete(`/teams/${teamID}/unlinkDiscord`)).data;
	},

	async getRaidWishes(teamID: Guid, raidID: Guid): Promise<GetTeamRaidWishesResponse> {
		return (await axios().get(`/teams/${teamID}/wishes/${raidID}`)).data;
	},

	async getPremiumLevels(): Promise<any[]> {
		return (await axios().get("/teams/premium")).data;
	},
};